var version = "web/3.1.1";
export default version;
